import React from "react";
import List from "features/Warranty/WarrantyList";

const WarrantyList = () => {
  return <List />;
};

export default WarrantyList;
